<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<div class="full-height">
    <div class="border-bottom border-gray d-flex align-items-center justify-content-center mt-3 pb-3 mb-0 h5" i18n>
        <i class="ni ni-badge mr-3 "></i>
        Roles
    </div>

    <div class="px-5 py-4 border-bottom border-gray bg-lighter">
        <div class="content-wrapper">
            <button class="btn btn-link text-info d-flex align-items-center justify-content-center p-0 mb-2 font-weight-normal"
                [routerLink]="'../../'" i18n>
                <i class="ni ni-bold-left mr-1"></i> Back
            </button>
            <div class="d-flex justify-content-between">
                <h2 class="display-2" i18n>Manage Group Scope</h2>
            </div>
        </div>
    </div>

    <div class="p-5 mb-4 border-bottom flex-1">
        <div class="content-wrapper">

            <section class="row m-5">
                <div class="col p-0">
                    <app-group-details-card [group]="(group$ | async)"></app-group-details-card>
                </div>
            </section>


            <div class="mt-5"></div>

            <app-data-table-ajax #dataTableAjax
                 url="/roles/{{roleId}}/groups/{{groupId}}/scopes" 
                 limit="50" 
                 [columns]="roleGroupScopesColumn">

                <ng-template #actionTemplate let-row="row">
                    <button i18n type="button" class="btn btn-link p-0 m-0" (click)="$event.preventDefault(); $event.stopPropagation(); onRemoveRow(row)">
                        <img alt="Delete Role" title="Delete Role" class="row-icon" src="assets/_ionicons_svg_md-trash.svg" />
                    </button>
                </ng-template>
            </app-data-table-ajax>


            <!-- Add more Scopes -->

            <div *ngIf="!addScopeMode">
                <div class="mt-5"></div>
                <button class="btn col-2 btn-info" (click)="addScopes()" i18n>Add User Scope</button>
            </div>

            <ng-container *ngIf="addScopeMode">
                <h2 class="my-4" i18n>Select the scope</h2>
                <app-radio-select name="scopes" i18n-name [options]="scopes$ | async" (selectOption)="onSelectCategory($event)">
                </app-radio-select>

                <div *ngIf="_selectedCategory">
                    <h2 class="mt-4" i18n>Select Scope Names</h2>

                    <app-data-table-ajax #dataTableAjax 
                        url="/roles/scopes/{{ _selectedCategory.id }}" 
                        limit="5"
                        [columns]="scopeNamesTable" 
                        [excludedItems]="roleGroupScopes$ | async"
                        selectionType="multiClick" 
                        (rowClicked)="onSelectScopeNames($event)">
                    </app-data-table-ajax>
                </div>

                <div class="d-flex justify-content-end border-top border-gray px-5 py-3">
                    <button class="mr-auto btn btn-link-default" (click)="cancel()" i18n>Cancel
                    </button>
                    <button class="btn btn-info btn-size-normal" [disabled]="!isValid()" (click)="submit()" i18n>
                        Add User Scopes
                    </button>
                </div>
            </ng-container>
            <!-- End add More Scopes -->

        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/access-management/roles/role-details/role-details-groups-tab/role-details-group-scopes/role-details-group-scopes.component.html